<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
				<FormItem label="品牌" prop="name" class="sj">
					<Input v-model="formValidate.name" placeholder="请输入标题" maxlength="18"></Input>
				</FormItem>
				
				<FormItem label="备注" prop="remark" class="sj">
					<Input v-model="formValidate.remark" placeholder="请输入值"  maxlength="128" show-word-limit type="textarea"></Input>
				</FormItem>
				
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	import Region from '@/components/comm/region.vue'
	import Imgs from '@/components/comm/imgs.vue'
	export default {
		data() {
			return {
				url:'',
				formValidate: {
					name: '',
					remark: '',
				},
				ruleValidate: {
					name: [{
						required: true,
						message: '名称不能为空！！！',
						trigger: 'blur'
					}]

				}

			}
		},
		created() {
			
			let _this=this
			_this.url=http.url+"/file/img/xinwen"
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			handleSubmit(name) {
				let _this=this
				this.$refs[name].validate((valid) => {
					if (valid) {
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/oper/comm/brand/add/oper',
						    data: _this.formValidate,
							_this: _this,
							success: function(data) {
								_this.$Message.success('新增成功!');
								_this.$refs[name].resetFields();
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			}
		},
		components:{
			Region,Imgs
		},
		beforeRouteLeave(to, from, next) {
			to.meta.keepAlive = true;
			next();
		}, 
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/admin/brand/add.vue